// ext.js

// load both interfaces
require("./read-core");
require("./write-core");

exports.createCodec = require("./codec-base").createCodec;



//////////////////
// WEBPACK FOOTER
// ./local_modules/common/node_modules/msgpack-lite/lib/ext.js
// module id = 463
// module chunks = 0